@if (config(); as config) {
    <header sf-company-header [companyName]="config.name" [settings]="config.utilitySettings"></header>
    <div class="pattern-square"></div>
}
<router-outlet></router-outlet>
<footer sf-company-footer></footer>
